import React from 'react';
import Panel from 'muicss/lib/react/panel';
import Button from 'muicss/lib/react/button';
import Node from './Node';
import axios from 'axios';
import sortBy from 'lodash/sortBy';
import shuffle from 'lodash/shuffle';
import envs from '../env';
import {connect} from 'react-redux'

const ORDER_RANDOM = 'random';
const ORDER_ALPHABETICAL = 'alphabetical';

const NODES_PER_PAGE = 20;

axios.defaults.headers.common['Access-Control-Allow-Origin'] = "*"

class Nodes extends React.Component {
  constructor(props) {
    super(props);
    // Persist the random order so it's the same after switching
    // the order in the UI.
    this.shuffledList = shuffle(envs.NODES);
    this.alphabeticalList = sortBy(envs.NODES, ['name']);;

    this.state = {
      page: 1,
      order: ORDER_RANDOM,
      list: this.shuffledList,
      uptimeData: {}
    };
  }

  componentDidMount() {
    this.getUptimeData();
    this.interval = setInterval(() => this.getUptimeData(), 60*1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  getUptimeData() {
    axios.get('/api/nodes')
      .then(response => {

        this.setState({uptimeData: response.data});

      })
      .catch(err=>{
          console.log('err' , err);
      })
  }

  setOrder(order) {
    this.setState({order, page: 1});
  }

  movePage(p) {
    this.setState({page: this.state.page+p});
  }

  render() {
    let list;

    if (this.state.order == ORDER_ALPHABETICAL) {
      list = this.alphabeticalList;
    } else {
      list = this.shuffledList;
    }

    list = list.slice((this.state.page-1)*NODES_PER_PAGE, (this.state.page)*NODES_PER_PAGE);

    return (
      <div>
        <div className="mui-col-md-12">
          <div className="mui--pull-left">
            <Button variant="flat" size="small"
              disabled={this.state.order == ORDER_RANDOM}
              onClick={this.setOrder.bind(this, ORDER_RANDOM)}>
                <i className="material-icons"></i>
                <span className="mui--hidden-xs">{this.props.dictionary['randomOrder'][this.props.lang]}</span>
              </Button>
            <Button variant="flat" size="small"
              disabled={this.state.order == ORDER_ALPHABETICAL}
              onClick={this.setOrder.bind(this, ORDER_ALPHABETICAL)}>
                <i className="material-icons"></i>
                <span className="mui--hidden-xs">{this.props.dictionary['alphabeticalOrder'][this.props.lang]}</span>
              </Button>
          </div>
          <div className="mui--pull-right">
            {this.state.page > 1 ?
              <Button variant="flat" size="small"
                onClick={this.movePage.bind(this, -1)}>
                  &laquo; Prev<span className="mui--hidden-sm mui--hidden-xs"> page</span>
              </Button>
              : null}
            {this.state.page < envs.NODES.length / NODES_PER_PAGE ?
              <Button variant="flat" size="small"
                onClick={this.movePage.bind(this, 1)}>
                  Next<span className="mui--hidden-sm mui--hidden-xs"> page</span> &raquo;
              </Button>
              : null}
          </div>
        </div>
        <div className="mui--clearfix"></div>
        <div className="mui-col-md-12">
          {
            Object.values(list)
              .map(node => {

               

                if(this.props.network == 'live'){

                  if(node.id.indexOf('test') == -1){
                    return(
                      <Node key={node.id} data={node} uptime={this.state.uptimeData[node.id]} />
                    )
                  }

                }else{

                  if(node.id.indexOf('test') != -1){
                    return(
                      <Node key={node.id} data={node} uptime={this.state.uptimeData[node.id]} />
                    )
                  }

                }

                
              })
          }
        </div>
      </div>
    );
  }
}



const mapStateToProps = ({ CommonReducer }) => {
  return {
    language: CommonReducer.language,
    network: CommonReducer.network,
  };
};


export default connect(mapStateToProps)(Nodes)



// WEBPACK FOOTER //
// ./frontend/components/Nodes.js